'use strict';

import React, { Component } from 'react';


class ProfileBoxItemBoxStatus extends Component{
    state ={
            //Initiate Time for the chart
            BoxInfoStatus: 'pmb-block',
            MenuBoxInfoStatus: 'dropdown',
        }
    showMenuBoxInfo= (e) => {
        e.preventDefault();
        this.props.reloadInfo();
        if (this.state.MenuBoxInfoStatus === 'dropdown open') {
            this.setState({MenuBoxInfoStatus: 'dropdown'});
        } else {
            this.setState({MenuBoxInfoStatus: 'dropdown'});
            //this.setState({MenuBoxInfoStatus: 'dropdown open'});
        }
    }
    showEditMenuBoxInfo= (e) => {
        e.preventDefault();
        this.setState({MenuBoxInfoStatus: 'dropdown', BoxInfoStatus: 'pmb-block toggled'});
    }
    closeBoxInfo= (e) => {
        e.preventDefault();
        this.setState({MenuBoxInfoStatus: 'dropdown', BoxInfoStatus: 'pmb-block'});
    }
    saveBoxInfo= (e) => {
        e.preventDefault();
        //Collect Information And Send this information update to BackEnd

        //Replace information
        this.setState({MenuBoxInfoStatus: 'dropdown', BoxInfoStatus: 'pmb-block'});
    }
    render() {

        return (

            <div className={this.state.BoxInfoStatus}>
                <div className="pmbb-header">
                    <h2>
                        <i className="zmdi zmdi-remote-control m-r-5"></i>
                        Caractéristiques de la box</h2>

                    <ul className="actions">
                        <li className={this.state.MenuBoxInfoStatus}>
                            <a href="#" data-toggle="dropdown" onClick={this.showMenuBoxInfo}>
                                <i className="zmdi zmdi-refresh-sync"></i>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a data-pmb-action="Refresh" href="#" onClick={this.showEditMenuBoxInfo}>Edit</a>
                                </li>
                                <li>
                                    <a data-pmb-action="Suppresx Box" href="#" onClick={this.showEditMenuBoxInfo}>Edit</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className="pmbb-body p-l-30">
                    <div className="pmbb-view">
                        <dl className="dl-horizontal">
                            <dt>Numero de la Box</dt>
                            <dd>{this.props.idBox}</dd>
                        </dl>
                        {this.props.addressMac !== ""?
                        <dl className="dl-horizontal">
                            <dt>Adress Mac de la Box</dt>
                            <dd>{this.props.addressMac}</dd>
                        </dl>
                        :<div></div>}
                        {this.props.ipAdress !== "" ?
                        <dl className="dl-horizontal">
                            <dt>Adresse IP local</dt>
                            <dd>{this.props.ipAdress}</dd>
                        </dl>
                        :<div></div>}
                        <dl className="dl-horizontal">
                            <dt>Status</dt>
                            <dd>{this.props.status}</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Dernière connexion</dt>
                            <dd>{this.props.lastConnexion}</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Version</dt>
                            <dd>{this.props.version}</dd>
                        </dl>
                    </div>

                    <div className="pmbb-edit">
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Numero de la Box</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="text" className="form-control" placeholder="eg. 00971 12345678 9"/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Adress Mac de la Box</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="email" className="form-control" placeholder="eg. 00:44:64:98:12:09:34"/>
                                </div>
                            </dd>
                        </dl>

                        <div className="m-t-30">
                            <button className="btn btn-primary btn-sm" onClick={this.saveBoxInfo}>Save</button>
                            <button data-pmb-action="reset" className="btn btn-link btn-sm" onClick={this.closeBoxInfo}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
};
export default ProfileBoxItemBoxStatus
//module.exports = ProfileBoxItemBoxStatus;
